import { render, staticRenderFns } from "./menuPrincipal.vue?vue&type=template&id=35390862&scoped=true"
import script from "./menuPrincipal.vue?vue&type=script&lang=js"
export * from "./menuPrincipal.vue?vue&type=script&lang=js"
import style0 from "./menuPrincipal.vue?vue&type=style&index=0&id=35390862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35390862",
  null
  
)

export default component.exports